import * as PayAndGoActions from '../actions/pay-and-go.actions';

export interface PayAndGoState {
  success: boolean;
  closed: boolean;
}

export const initialState: PayAndGoState = {
  success: undefined,
  closed: undefined,
};

export function reducer(
  state: PayAndGoState = initialState,
  action: PayAndGoActions.Actions,
): PayAndGoState {
  switch (action.type) {
    case PayAndGoActions.ORDER_PAY_AND_GO_SUCCESS:
      return {
        ...state,
        success: true,
      };
    case PayAndGoActions.ORDER_PAY_AND_GO_FAILURE:
      return {
        ...state,
        success: false,
      };
    case PayAndGoActions.CLOSE_PAY_AND_GO_MODAL:
      return {
        ...state,
        closed: true,
      };
    case PayAndGoActions.RESET_PAY_AND_GO:
      return initialState;
    default:
      return state;
  }
}

export const getOrderPayAndGoSuccess = (state: PayAndGoState) => state.success;
export const getOrderPayAndGoModalClosed = (state: PayAndGoState) =>
  state.closed;
